var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom"},[_vm._v("\n   ©2019 108hill-office & residence. All rights reserved.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }